// PickupMethodsSelector.tsx
import React from "react";
import { UseFormSetValue, UseFormWatch } from "react-hook-form";
import { Page3FormData } from "../../../pages/owner/store/CreateStorePageThree";
import { useTranslation } from "react-i18next";

interface Props {
  watch: UseFormWatch<Page3FormData>;
  setValue: UseFormSetValue<Page3FormData>;
}

const PickupMethodsSelector: React.FC<Props> = ({ watch, setValue }) => {
  const pickupValues = watch("pickupMethods");

  const togglePickup = (type: keyof typeof pickupValues) => {
    setValue(`pickupMethods.${type}`, !pickupValues[type], { shouldValidate: true });
  };

  const {t} = useTranslation();

  return (
    <div>
      <div className="flex gap-4 w-[300px]">
        <button
          type="button"
          className={`flex-1 py-2 rounded-2xl ${
            pickupValues.in_store ? "bg-primaryButton text-white" : "bg-LightGrey1"
          }`}
          onClick={() => togglePickup("in_store")}
        >
            {t('in_store')}
        </button>
        <button
          type="button"
          className={`flex-1 py-2 rounded-2xl ${
            pickupValues.drive_thru ? "bg-primaryButton text-white" : "bg-LightGrey1"
          }`}
          onClick={() => togglePickup("drive_thru")}
        >
            {t("drive_thru")}
        </button>
      </div>
    </div>
  );
};

export default PickupMethodsSelector;
